import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { GocardlessMandate } from '~direct-debits/models';

interface ComponentProps {
  row: { status: GocardlessMandate['status'] };
}

// Thin wrapper over the shared LookupStatusBadge: forwards the API-supplied
// `{tag, name, colour}` and tags the data-cy hook for selectors used by the
// mandate-matching screen.
const MandateStatusBadge: React.FC<ComponentProps> = ({ row }) => (
  <LookupStatusBadge
    status={row.status}
    dataCy={`dd-mandate-matching-status-${row.status.tag}`}
  />
);

export default MandateStatusBadge;
